/* eslint-disable no-nested-ternary */
import 'react-datepicker/dist/react-datepicker.css';

import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';

import Form from '../../../components/form/form';
import addNotification from '../../../components/notification';
import DualList from '../../../components/pages/DualList';

import ROUTES from '../../../config/routes';

import {
  createAccessProfile,
  updateAccessProfile,
  getAccessProfile,
  getRangesPriority,
} from '../../../app/store/actions/accessProfile';
import { getBranchesOptions } from '../../../app/store/actions/branches';
import { getRangesList } from '../../../app/store/actions/ranges';

class DevelopAccessProfileForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      mode: 'detail',
      code: '',
      name: '',
      branchCode: '',
      branchName: '',
      listBranch: [],
      selectedRangesPriority: [],
      rangesPriorityByBranch: {},
      loadedBranches: [],
      disableCode: true,
      disableName: true,
      disableRangesPriority: true,
      showCreate: false,
      showUpdate: false,
      showCancel: false,
    };
  }

  async componentDidMount() {
    await this.setMode();
    await this.getOptions();
    if (this.state.mode === 'create') {
      // do something
    } else {
      await this.getAccessProfileSelected();
    }
  }

  getOptions = async () => {
    await this.props.getRangesList();

    const listBranch = await this.props.getBranchesOptions();

    if (listBranch) {
      this.setState({ listBranch });
    }

    return listBranch;
  };

  getAccessProfileSelected = async () => {
    if (this.props.location.state.accessProfile) {
      const { accessProfile } = this.props.location.state;

      const accessProfileSelected = await this.props.getAccessProfile(accessProfile.code);

      if (accessProfileSelected) {
        const rangesPriorityByBranch = this.state.mode === 'copy'
          ? await this.getRangesPriorityByBranch(accessProfile.code)
          : accessProfileSelected.rangesPriorityByBranch || {};

        this.setState({
          code: accessProfileSelected.code,
          name: accessProfileSelected.name,
          permissions: accessProfileSelected.permissions,
          mobilePermissions: accessProfileSelected.mobilePermissions,
          rangesPriorityByBranch,
          loadedBranches: Object.keys(rangesPriorityByBranch),
        });
      }
    }
  };

  getRangesPriorityByBranch = async (code) => {
    const rangesPriorityByBranch = {};
    const branches = this.state.listBranch || [];

    await Promise.all(branches.map(async (branch) => {
      const loaded = await this.props.getRangesPriority(code, branch.value);
      rangesPriorityByBranch[branch.value] = (loaded || []).map((item) => (
        typeof item === 'string' ? item : item.rangeCode
      ));
    }));

    return rangesPriorityByBranch;
  };

  setMode = () => {
    const mode = this.props.isCreate ? 'create'
      : this.props.isCopy ? 'copy'
        : this.props.isEdit ? 'edit'
          : this.props.isDetail ? 'detail' : '';

    if (mode === 'create' || mode === 'copy') {
      this.setState({
        mode,
        disableCode: false,
        disableName: false,
        disableRangesPriority: false,
        showCreate: true,
        showUpdate: false,
        showCancel: true,
      });
    } else if (mode === 'edit') {
      this.setState({
        mode,
        disableCode: true,
        disableName: false,
        disableRangesPriority: false,
        showCreate: false,
        showUpdate: true,
        showCancel: true,
      });
    }
  };

  setValue = async (attr, value) => {
    await this.setState({
      [`${attr}`]: value,
    });
  };

  setValueDrop = async (attr, value) => {
    if (attr === 'branch') {
      await this.changeBranch(value);
      return;
    }

    await this.setState({
      [`${attr}Code`]: value ? value.value : '',
      [`${attr}Name`]: value ? value.label : '',
    });
  };

  changeBranch = async (value) => {
    const {
      branchCode: previousBranchCode,
      selectedRangesPriority: previousSelected,
      rangesPriorityByBranch: currentRangesPriorityByBranch,
      mode,
      code,
      loadedBranches,
    } = this.state;
    const rangesPriorityByBranch = { ...currentRangesPriorityByBranch };

    if (previousBranchCode) {
      rangesPriorityByBranch[previousBranchCode] = previousSelected;
    }

    const nextBranchCode = value ? value.value : '';
    const nextBranchName = value ? value.label : '';
    let nextSelected = [];

    let nextLoadedBranches = loadedBranches;

    if (!nextBranchCode) {
      nextSelected = [];
    } else if (loadedBranches.includes(nextBranchCode)) {
      nextSelected = rangesPriorityByBranch[nextBranchCode] || [];
    } else if (mode !== 'create' && code) {
      const loaded = await this.props.getRangesPriority(code, nextBranchCode);
      nextSelected = (loaded || []).map((item) => (
        typeof item === 'string' ? item : item.rangeCode
      ));
      rangesPriorityByBranch[nextBranchCode] = nextSelected;
      nextLoadedBranches = [...loadedBranches, nextBranchCode];
    } else {
      nextSelected = [];
    }

    this.setState({
      branchCode: nextBranchCode,
      branchName: nextBranchName,
      selectedRangesPriority: nextSelected,
      rangesPriorityByBranch,
      loadedBranches: nextLoadedBranches,
    });
  };

  onChangeDualList = (selected) => {
    this.setState({ selectedRangesPriority: selected });
  };

  getRangesPriorityPayload = () => {
    const {
      branchCode, selectedRangesPriority, rangesPriorityByBranch,
    } = this.state;
    const payloadByBranch = { ...rangesPriorityByBranch };

    if (branchCode) {
      payloadByBranch[branchCode] = selectedRangesPriority;
    }

    return payloadByBranch;
  };

  createAccessProfileSubmit = async () => {
    const {
      code, name, permissions, mobilePermissions,
    } = this.state;
    const rangesPriorityByBranch = this.getRangesPriorityPayload();

    try {
      const newAccessProfile = await this.props.createAccessProfile({
        code,
        name,
        rangesPriorityByBranch,
        permissions,
        mobilePermissions,
      });

      if (newAccessProfile && typeof newAccessProfile !== 'object') {
        await addNotification(
          'success',
          I18n.t('BEE249' /* Novo Perfil de Acesso */),
          I18n.t('BEE250', { 0: code } /* Novo Perfil %{0} incluído com sucesso! */),
          'top-right',
        );
        this.props.history.push(ROUTES.DEVELOP_ACCESS_PROFILE_LIST);
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE249' /* Novo Perfil de Acesso */),
          I18n.t('BEE251', { 0: code } /* Erro ao incluir o Perfil de Acesso %{0}! */),
          'top-right',
        );
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE249' /* Novo Perfil de Acesso */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE249' /* Novo Perfil de Acesso */),
            I18n.t('BEE251', { 0: code } /* Erro ao incluir o Perfil de Acesso %{0}! */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE249' /* Novo Perfil de Acesso */),
          I18n.t('BEE251', { 0: code } /* Erro ao incluir o Perfil de Acesso %{0}! */),
          'top-right',
        );
      }
    }
  };

  updateAccessProfile = async () => {
    const { code, name } = this.state;
    const rangesPriorityByBranch = this.getRangesPriorityPayload();

    try {
      const updAccessProfile = await this.props.updateAccessProfile({
        code,
        name,
        rangesPriorityByBranch,
      });

      if (updAccessProfile && updAccessProfile instanceof Array && updAccessProfile.length) {
        await addNotification(
          'success',
          I18n.t('BEE252' /* Atualizar Perfil de Acesso */),
          I18n.t('BEE253', { 0: code } /* Atualização do Perfil de Acesso %{0} efetuado com sucesso! */),
          'top-right',
        );
        this.props.history.push(ROUTES.DEVELOP_ACCESS_PROFILE_LIST);
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE252' /* Atualizar Perfil de Acesso */),
          I18n.t('BEE254', { 0: code } /* Erro ao atualizar o Perfil de Acesso %{0}! */),
          'top-right',
        );
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.error) {
        const { error } = err.response.data;

        if (error.details || error.message) {
          await addNotification(
            'danger',
            I18n.t('BEE252' /* Atualizar Perfil de Acesso */),
            `${error.code} - ${error.details || error.message}`,
            'top-right',
          );
        } else {
          await addNotification(
            'danger',
            I18n.t('BEE252' /* Atualizar Perfil de Acesso */),
            I18n.t('BEE254', { 0: code } /* Erro ao atualizar o Perfil de Acesso %{0}! */),
            'top-right',
          );
        }
      } else {
        await addNotification(
          'danger',
          I18n.t('BEE252' /* Atualizar Perfil de Acesso */),
          I18n.t('BEE254', { 0: code } /* Erro ao atualizar o Perfil de Acesso %{0}! */),
          'top-right',
        );
      }
    }
  };

  render() {
    const {
      mode, code, name, disableCode, disableName,
      branchCode, branchName, listBranch,
      disableRangesPriority, selectedRangesPriority,
      showCreate, showUpdate, showCancel,
    } = this.state;

    const optionsRangesPriority = (this.props.rangesList || [])
      .filter((range) => branchCode && range.branchCode === branchCode)
      .map((range) => ({
        value: range.code,
        label: `${range.code} - ${range.name}`,
      }));

    let title = '';

    if (mode === 'create' || mode === 'copy') {
      title = I18n.t('BEE249' /* Novo Perfil de Acesso */);
    } else if (mode === 'edit') {
      title = I18n.t('BEE255' /* Editar Perfil de Acesso */);
    } else if (mode === 'detail') {
      title = I18n.t('BEE256' /* Detalhes Perfil de Acesso */);
    }

    return (
      <div>
        <div className="d-flex align-items-center">
          <ol className="breadcrumb float-xl-left">
            <li className="breadcrumb-item">
              <i className="fas fa-home fa-fw m-t-10 m-r-5" />
              {' '}
              {I18n.t('BEE12' /* Início */)}
            </li>
            <li className="breadcrumb-item">{I18n.t('BEE13' /* Administração */)}</li>
            <li className="breadcrumb-item">{I18n.t('BEE25' /* Usuários */)}</li>
            <li className="breadcrumb-item active">{I18n.t('BEE247' /* Perfil de Acesso */)}</li>
          </ol>
        </div>
        <Form
          title={title}
          noButton
          mode={mode}
          setValue={this.setValue}
          setValueDrop={this.setValueDrop}
          linkBack={{ pathname: ROUTES.DEVELOP_ACCESS_PROFILE_LIST, state: { dice: this.props.location.dice } }}
          showCancel={showCancel}
          showCreate={showCreate}
          onSubmitCreate={() => this.createAccessProfileSubmit()}
          showUpdate={showUpdate}
          onSubmitUpdate={() => this.updateAccessProfile()}
          inputs={(formContext) => ([
            formContext.createInput(
              code,
              'code',
              `${I18n.t('BEE82' /* Código */)}:`,
              I18n.t('BEE3716' /* Informe o perfil de acesso */),
              'text',
              true,
              disableCode,
            ),
            formContext.createInput(
              name,
              'name',
              `${I18n.t('BEE83' /* Nome */)}:`,
              I18n.t('BEE3717' /* Informe o nome do perfil de acesso */),
              'text',
              true,
              disableName,
            ),
            <DualList
              key="rangesPriority"
              id="dualselectrangespriority"
              title={`${I18n.t('BEE4802' /* Prioridade de Ranges */)}`}
              availableHeader={I18n.t('BEE4511' /* Ranges Disponíveis */)}
              selectedHeader={I18n.t('BEE4512' /* Ranges Selecionados */)}
              filterPlaceholder={I18n.t('BEE541' /* Filtrar... */)}
              options={optionsRangesPriority}
              selected={selectedRangesPriority}
              onChange={(item) => this.onChangeDualList(item)}
              disabled={disableRangesPriority}
            />,
            <div key="branch" className="mt-4">
              <Form
                noPanel
                setValue={this.setValue}
                setValueDrop={this.setValueDrop}
                inputs={(branchContext) => ([
                  branchContext.createSelectDropDown(
                    { value: branchCode, label: branchName },
                    'branch',
                    `${I18n.t('BEE145' /* Filial */)}:`,
                    listBranch,
                    false,
                  ),
                ])}
              />
            </div>,
          ])}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  rangesList: state.ranges && state.ranges.rangesList,
});

const mapDispatchToProps = (dispatch) => ({
  getAccessProfile: (code) => dispatch(getAccessProfile(code)),
  createAccessProfile: (accessProfile) => dispatch(createAccessProfile(accessProfile)),
  updateAccessProfile: (accessProfile) => dispatch(updateAccessProfile(accessProfile)),
  getRangesList: () => dispatch(getRangesList()),
  getBranchesOptions: () => dispatch(getBranchesOptions()),
  getRangesPriority: (code, branchCode) => dispatch(getRangesPriority(code, branchCode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DevelopAccessProfileForm));
